import * as React from 'react';
import { GridDayProps } from '../../components/grid/day';

import * as moment from 'moment';
import GridEventView from 'grid-event.view';
import { LoadMoreProps } from '../../components/month-selection/load-more';
import { scrollToMonth } from '../../helpers/scroll-to-month';

const NextMonthView: React.StatelessComponent<LoadMoreProps> = props => {
    function onClick(evt: React.MouseEvent<HTMLButtonElement>) {
        evt.preventDefault();

        props.goToNextMonth();
        const nextMonth = props.currDate.clone().add(1, "month").startOf("month");

        var focusDestinationMonth = setInterval(() => {
            if (scrollToMonth(nextMonth)) {
                clearInterval(focusDestinationMonth);
            }
        }, 500);

    }

    return (
        <p className="align-center space-top-lg border-top">
            <button type="button" onClick={onClick} className="btn">
                {props.text.loadMoreEventsButtonText}
            </button>
        </p>
    );
}

export default NextMonthView;